
import { useTodoAddMutation } from './useTodoAddMutation';
import { useTodoToggleMutation } from './useTodoToggleMutation';
import { useTodoDeleteMutation } from './useTodoDeleteMutation';
import { useTodoDueDateMutation } from './useTodoDueDateMutation';
import { useTodoUpdateMutation } from './useTodoUpdateMutation';

export const useTodoMutations = () => {
  const { addTodo } = useTodoAddMutation();
  const { toggleTodo } = useTodoToggleMutation();
  const { deleteTodo } = useTodoDeleteMutation();
  const { updateTodoDueDate } = useTodoDueDateMutation();
  const { updateTodoText } = useTodoUpdateMutation();

  return {
    addTodo,
    toggleTodo,
    deleteTodo,
    updateTodoDueDate,
    updateTodoText
  };
};
